module.exports = __webpack_public_path__ + "static/media/50n.1186186b.svg";